import React from "react";
import { Stack, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { HubButton } from "../../components";
import {
  MODE_DAILY,
  getQuarterFromDate,
  getQuarterRange,
  resolveRange,
} from "../../pages/SchedulePage/dateHelper";

const QuarterSelector = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { startDate } = resolveRange(searchParams, MODE_DAILY);
  const { year, quarter } = getQuarterFromDate(startDate);

  const setQuarter = (y, q) => {
    const range = getQuarterRange(y, q);
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("startDate", range.startDate);
      next.set("endDate", range.endDate);
      return next;
    });
  };

  const goPrev = () =>
    quarter === 1 ? setQuarter(year - 1, 4) : setQuarter(year, quarter - 1);
  const goNext = () =>
    quarter === 4 ? setQuarter(year + 1, 1) : setQuarter(year, quarter + 1);

  return (
    <Stack direction="row" alignItems="center" gap="5px">
      <HubButton
        variant="text"
        size="xsmall"
        icon="ChevronLeft"
        onClick={goPrev}
        iconProps={{ size: "14px" }}
      />
      <Typography variant="caption11" sx={{ minWidth: 60, textAlign: "center" }}>
        Q{quarter} {year}
      </Typography>
      <HubButton
        variant="text"
        size="xsmall"
        icon="ChevronRight"
        onClick={goNext}
        iconProps={{ size: "14px" }}
      />
    </Stack>
  );
};

export default QuarterSelector;
